export const NOTIFICATION_TEST_ID = 'Notification';
